// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ProposalFile = zod.object({
  "chars_read": zod.int(),
  "cut": zod.boolean(),
  "filename": zod.string(),
  "id": zod.uuid(),
  "language": zod.union([zod.string(),zod.null()]),
  "truncated": zod.boolean()
});

export type ProposalFile = zod.input<typeof ProposalFile>;
export type ProposalFileOutput = zod.output<typeof ProposalFile>;
